<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="500px" persistent>
    <v-card>
      <v-card-title class="title">Posting Link</v-card-title>
      <v-card-text class="mt-3 body-2">
        <v-text-field
          v-model="postingLink"
          type="text"
          hide-details
          @input="$v.postingLink.$touch()"
          :error-messages="postingLink"
          @blur="$v.postingLink.$touch()"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-btn color="red" id="close" text @click.native="close()">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="green" text @click="save()" :disabled="$v.postingLink.$invalid">Save</v-btn>
      </v-card-actions>
    </v-card>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="90"
      height.number="90"
    ></loading>
  </v-dialog>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import Loading from 'vue-loading-overlay';
export default {
  name: 'PostLinkUpdateModal',
  components: {
    Loading
  },
  props: {
    value: Boolean,
    item: Object
  },
  validations: {
    postingLink: {
      required
    }
  },
  data () {
    return {
      isLoading: false,
      postingLink: ''
    }
  },
  async mounted() {
  },
  computed: {
    postingLinkErrors() {
      const errors = [];
      if (!this.$v.postingLink.$dirty) return errors;
      !this.$v.postingLink.required && errors.push('This field is required.');
      return errors;
    }
  },
  watch: {
    item: function(newValue) {
      this.postingLink = ''
      if (newValue.postingLink) {
        this.postingLink = newValue.postingLink
      }
    }
  },
  methods: {
    save() {
      this.item.postingLink = this.postingLink
      this.$emit('saveClicked', this.item)
      this.$emit('input')
    },
    close() {
      this.$emit('closeClicked', this.item)
      this.$emit('input')
    }
  }
};
</script>



// WEBPACK FOOTER //
// PostLinkUpdateModal.vue?58703b56